import styled from '@emotion/styled'
import { Stack } from '@mui/material'
import Link from 'next/link'
import { FC, PropsWithChildren } from 'react'
import { AntelopeLogo } from 'components/Branding/AntelopeLogo'
import { MilesRepublicLogo } from 'components/Branding/MilesRepublicLogo'
import { TrackingScript } from 'components/TrackingScript'
import { StyledCheckoutLayoutContainer } from 'components/pages/step.style'

interface CheckoutLayoutContainerProps extends PropsWithChildren<{}> {
  isLogoClickable?: boolean
}

export const StyledLinkWithoutDecoration = styled(Link)`
  color: inherit;
  cursor: pointer;
  text-decoration: none;
`

export const CheckoutLayoutContainer: FC<CheckoutLayoutContainerProps> = ({
  children,
  isLogoClickable = false
}) => {
  return (
    <StyledCheckoutLayoutContainer>
      <TrackingScript />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={4.25}
      >
        {isLogoClickable ? (
          <StyledLinkWithoutDecoration href="/" passHref>
            <MilesRepublicLogo />
          </StyledLinkWithoutDecoration>
        ) : (
          <MilesRepublicLogo />
        )}
        <AntelopeLogo />
      </Stack>
      {children}
    </StyledCheckoutLayoutContainer>
  )
}
